/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangePasswordInput } from '../../models/change-password-input';
import { Response } from '../../models/response';

export interface ApiIdentityAccountChangepasswordPut$Plain$Params {
      body?: ChangePasswordInput
}

export function apiIdentityAccountChangepasswordPut$Plain(http: HttpClient, rootUrl: string, params?: ApiIdentityAccountChangepasswordPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
  const rb = new RequestBuilder(rootUrl, apiIdentityAccountChangepasswordPut$Plain.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Response>;
    })
  );
}

apiIdentityAccountChangepasswordPut$Plain.PATH = '/api/identity/account/changepassword';
